<script>
    import DurationDisplay from '../../common/DurationDisplay.svelte';

    export let col = {}
    export let label = '';

</script>

<style>
    .icon {
        font-size: 0.69rem;
    }
</style>

{#if col.iconClass}
    <span class='icon'>
        <i class="fas {col.iconClass}"></i>
    </span>

    <DurationDisplay seconds={label} />
{:else}
    <span>{label}</span>
{/if}
